import React, { useEffect, useState } from "react";
import { ArrowUpLeft, BriefcaseBusiness, GraduationCap, ShieldCheck } from "lucide-react";
import Logo from "../../assets/img/NewsImgs/logo192.png";
import SignInImage from "../../assets/img/auth/sign-in-journey.png";
import SignUpImage from "../../assets/img/auth/sign-up-community.png";
import "./AuthLayout.css";
import { useLanguage } from "../../i18n/LanguageContext";

const content = {
    signIn: {
        image: SignInImage,
        eyebrow: "مسیر بین‌المللی شما",
        title: "فرصت مناسب، از یک تصمیم درست شروع می‌شود.",
        text: "همه درخواست‌ها، فرصت‌ها و ارتباطات حرفه‌ای خود را در یک فضای منظم مدیریت کنید.",
        stat: "۱۰۰۰+",
        statLabel: "فرصت فعال تحصیلی و شغلی",
        icon: BriefcaseBusiness,
        alt: "برنامه‌ریزی برای مسیر شغلی بین‌المللی",
    },
    signUp: {
        image: SignUpImage,
        eyebrow: "آینده بدون مرز",
        title: "مسیر تازه‌ات را با آدم‌های درست بساز.",
        text: "به جامعه‌ای از متقاضیان بین‌المللی بپیوندید و قدم‌های بعدی را شفاف‌تر بردارید.",
        stat: "۵۰+",
        statLabel: "کشور در شبکه فرصت‌های ما",
        icon: GraduationCap,
        alt: "همکاری دانشجویان بین‌المللی برای اپلای",
    },
};

const AuthLayout = ({ mode = "signIn", children }) => {
    const [ready, setReady] = useState(false);
    const { isEnglish, direction, toggleLanguage } = useLanguage();
    const englishContent = mode === "signIn" ? { eyebrow: "Your international journey", title: "The right opportunity starts with the right decision.", text: "Manage your applications, opportunities, and professional outreach in one organized workspace.", stat: "1,000+", statLabel: "active academic and career opportunities", alt: "Planning an international career path" } : { eyebrow: "A future without borders", title: "Build your next path with the right people.", text: "Join international applicants and take your next steps with greater clarity.", stat: "50+", statLabel: "countries in our opportunity network", alt: "International applicants preparing their journey" };
    const item = isEnglish ? { ...content[mode], ...englishContent } : content[mode];
    const FeatureIcon = item.icon;

    useEffect(() => {
        const frame = requestAnimationFrame(() => setReady(true));
        return () => cancelAnimationFrame(frame);
    }, []);

    return (
        <main className="auth-page" dir={direction}>
            <div className={`auth-card auth-card--${mode} ${ready ? "auth-card--ready" : ""}`}>
                <section className="auth-visual" aria-label={isEnglish ? "About Infinity Apply" : "درباره اینفینیتی اپلای"}>
                    <img className="auth-visual__image" src={item.image} alt={item.alt} />
                    <div className="auth-visual__shade" />

                    <a className="auth-brand" href="/" aria-label={isEnglish ? "Back to Infinity Apply" : "بازگشت به اینفینیتی اپلای"}>
                        <span className="auth-brand__logo"><img src={Logo} alt="" /></span>
                        <span><strong>Infinity Apply</strong><small>{isEnglish ? "Study, Work, Future" : "تحصیل، کار، آینده"}</small></span>
                    </a>

                    <div className="auth-story">
                        <span className="auth-story__eyebrow"><FeatureIcon size={16} />{item.eyebrow}</span>
                        <h2>{item.title}</h2>
                        <p>{item.text}</p>
                    </div>

                    <div className="auth-proof">
                        <div><strong>{item.stat}</strong><span>{item.statLabel}</span></div>
                        <span className="auth-proof__icon"><ArrowUpLeft size={21} /></span>
                    </div>
                    <div className="auth-secure"><ShieldCheck size={15} /> {isEnglish ? "Your information remains secure and confidential" : "اطلاعات شما امن و محرمانه می‌ماند"}</div>
                </section>

                <section className="auth-form-panel">
                    <button className="auth-language-toggle" type="button" onClick={toggleLanguage}>{isEnglish ? "FA" : "EN"}</button>
                    <a className="auth-mobile-brand" href="/">
                        <img src={Logo} alt="Infinity Apply" />
                        <span><strong>Infinity Apply</strong><small>{isEnglish ? "Study, Work, Future" : "تحصیل، کار، آینده"}</small></span>
                    </a>
                    {children}
                </section>
            </div>
        </main>
    );
};

export default AuthLayout;
